module.exports = __webpack_public_path__ + "images/daa11fbbac47f586d4b937e9bfa80a6a.svg";